import { AuditColumnModel, ZoneNatureLevelType } from 'src/app/model';

export interface ZoneListModel
  extends Pick<AuditColumnModel, '_id'>,
    ZoneEntityCountModel {
  siteId: string;
  name: string;
  parentId: string | null;
  nature: ZoneNatureLevelType;
  floorPlan: any;
  geoFence: any;
  depth?: number;
  childCount?: number;
  order?: number;
}

export interface ZoneListHierarchyModel extends ZoneListModel {
  children?: ZoneListHierarchyModel[];
}

export interface ZoneEntityCountModel {
  assetCount: number;
  deviceCount: number;
}
